<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7043 13.0102C20.4039 10.3594 17.225 7.3125 13 7.3125C11.2937 7.3125 9.72969 7.79492 8.0793 8.82578C6.68789 9.69922 5.26094 10.9281 3.30078 12.9492L3.25 13L3.59023 13.3504C6.38828 16.2145 8.80547 18.6875 13 18.6875C14.8535 18.6875 16.6512 18.0832 18.4945 16.8391C20.0637 15.7777 21.3992 14.432 22.4707 13.3453L22.75 13.066L22.7043 13.0102ZM13 17.0625C10.7605 17.0625 8.9375 15.2395 8.9375 13C8.9375 10.7605 10.7605 8.9375 13 8.9375C15.2395 8.9375 17.0625 10.7605 17.0625 13C17.0625 15.2395 15.2395 17.0625 13 17.0625Z"
      fill="#666666"
    />
    <path
      d="M12.7156 11.5172C12.7156 11.1668 12.8172 10.8367 12.9949 10.5625C11.6492 10.5625 10.5625 11.6594 10.5625 13.0102C10.5625 14.3609 11.6543 15.4527 12.9949 15.4527C14.3355 15.4527 15.4324 14.3609 15.4324 13.0102C15.1582 13.1879 14.8281 13.2895 14.4777 13.2895C13.5078 13.2844 12.7156 12.4922 12.7156 11.5172Z"
      fill="#666666"
    />
  </svg>
</template>
